// extracted by mini-css-extract-plugin
module.exports = {"list_table":"styles_list_table__1ZKg_","actions_icons":"styles_actions_icons__Gzp_b"};